/*
 * @Author: edvardchen
 * @Date: 2018-01-11 11:10:03
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-08-19 17:22:17
 */

// @flow
import _ from 'lodash';
import Url from 'url';
import querystring from 'query-string';
import cookies from 'js-cookie';
import PromiseTImeout from './promise-timeout';
const C_TIMEOUT = 2000;
/* eslint no-bitwise: ["error", { "allow": ["<<","&="] }] */
const newToken = function (_t) {
  let hash = 441250815;
  if (_t) {
    _t.split('').forEach((elem, index) => {
      hash += (hash << 5) + _t.charCodeAt(index);
    });
    hash &= 0x7fffffff;
  } else {
    hash &= new Date().getTime();
  }
  return hash;
};
export const formatToken = () => {
  if (!__CLIENT__) {
    return {};
  }
  const qua = cookies.get('qb_qua') || '';
  const guid = cookies.get('qb_guid') || '';
  const ua = _.get(window, 'navigator.userAgent') || '';
  const href = (window && window.location.href) || '';
  // const hash = _.get(window, 'CONSTANTS.hash') || '';
  let docId = '';
  try {
    // eslint-disable-next-line prefer-destructuring
    docId = querystring.parse(Url.parse(href).query).docId;
  } catch (error) {
    console.log(error);
  }
  const _t = guid + qua + ua + docId;
  const hash = newToken(_t);
  const refer = (document && document.referrer) || '';
  const token = {
    R1: ua,
    R2: refer,
    R3: hash,
    R4: qua,
    R5: href,
    R6: 1,
  };
  Object.keys(token).forEach((key) => {
    Object.defineProperty(token, key, {
      writable: false,
      configurable: false,
    });
  });
  return token;
};
const getQIMEI = () =>
  new Promise((resolve) => {
    const handle = _.get(window, 'browser.device.getQIMEI');
    console.log('getQIMEI----1', handle);
    if (handle) {
      handle((data) => {
        console.log('getQIMEI----2', data);
        let qimei = '';
        if (typeof data === 'object') {
          qimei = data.QIMEI;
        } else {
          console.log('getQIMEI return wrong data', data);
        }
        resolve(qimei);
      }, resolve);
    } else {
      resolve();
    }
  });
const getIDFA = () =>
  new Promise((resolve) => {
    const handle = _.get(window, 'browser.app.getAdvertisingID');
    if (handle) {
      handle((str) => {
        resolve(str);
      });
    } else {
      resolve('');
    }
  });
const getWifiInfo = () =>
  new Promise((resolve) => {
    const handle = _.get(window, 'browser.device.getWifiInfo');
    if (handle) {
      handle((data) => {
        if (typeof data === 'object') {
          const { mac, ssid } = data;
          resolve({ mac, ssid });
        } else {
          console.error('browser.device.getWifiInfo wrong returned value', data);
        }
        resolve({});
      });
    } else {
      resolve({});
    }
  });
const getMacAddress = () =>
  new Promise((resolve) => {
    const handle = _.get(window, 'browser.device.getMacAddress');
    if (handle) {
      handle((address) => {
        const adrs = typeof address === 'object' ? JSON.stringify(address) : address;
        resolve(adrs);
      });
    } else {
      resolve();
    }
  });
const getQIMEI36 = () =>
  new Promise((resolve) => {
    const handle = _.get(window, 'browser.app.getBrowserParam');
    if (handle) {
      handle(
        (data) => {
          const qimei36 = typeof data === 'object' ? data.qimei36 : '';
          resolve(qimei36);
        },
        () => resolve(''),
      );
    }
  });
const getIDFV = () =>
  new Promise((resolve) => {
    const handle = _.get(window, 'browser.device.getIDFV');
    if (handle) {
      handle(resolve);
    } else {
      resolve('');
    }
  });
const getAndroidID = () =>
  new Promise((resolve) => {
    const handle = _.get(window, 'browser.device.getAndroidID');
    if (handle) {
      handle(
        (data) => {
          const androidID = data instanceof Object ? data.androidID : data;
          resolve(androidID);
        },
        () => {
          resolve('');
        },
      );
    } else {
      resolve('');
    }
  });

const getOAID = () =>
  new Promise((resolve) => {
    const handle = _.get(window, 'browser.device.getOAID');
    if (handle) {
      handle(
        (data) => {
          const androidID = data instanceof Object ? data.oaid : data;
          resolve(androidID);
        },
        () => {
          resolve('');
        },
      );
    } else {
      resolve('');
    }
  });
const getAppVersion = () =>
  new Promise((resolve) => {
    const handle = _.get(window, 'browser.app.getAppVersion');
    if (handle) {
      handle(resolve, () => {
        resolve('');
      });
    } else {
      resolve('');
    }
  });

const checkKingCardInfo = () =>
  new Promise((resolve) => {
    const handle = _.get(window, 'browser.app.checkKingCardInfo');
    if (handle) {
      handle(
        (data) => {
          resolve(data);
        },
        (err) => {
          console.error('checkKingCardInfo error:', err);
          resolve({});
        },
      );
    } else {
      resolve({});
    }
  });

export {
  getQIMEI,
  getIDFA,
  getWifiInfo,
  getMacAddress,
  getQIMEI36,
  getAndroidID,
  getIDFV,
  getAppVersion,
  getOAID,
  checkKingCardInfo,
};
export const promiseTimeout = (promiseFunc) => {
  return new Promise((resolve) => {
    if (promiseFunc instanceof Function) {
      promiseFunc().then(resolve);
    } else {
      resolve('');
    }
    setTimeout(() => {
      resolve('');
    }, 200);
  });
};
export const cheatingDefeatInfo = async () => {
  const [qimei36, appVersion, idfv, androidId, idfa, qimei] = await Promise.all([
    promiseTimeout(getQIMEI36),
    promiseTimeout(getAppVersion),
    promiseTimeout(getIDFV),
    promiseTimeout(getAndroidID),
    promiseTimeout(getIDFA),
    promiseTimeout(getQIMEI),
  ]);
  const info = `qimei36=${qimei36};app_version=${appVersion};idfv=${idfv};android_id=${androidId};idfa=${idfa};qimei=${qimei}`;
  console.log('cheatingDefeatInfo------', info);
  return info;
};
export default () => {
  const logData = {};
  const { browser } = window;
  if (typeof browser !== 'object' || !browser.define) {
    return;
  }

  /**
   *  C1 qq
      C2 微信openid
      C3 MAC
      C4 QIMEI
      C5 idfa
      C6 idfv
      C7 android_id
      C8 经度
      C9 维度
      C10 Wifi_mac
      C11 wifi_ssid
      C12 imsi
      C13 网络环境
      C14 imei
      C15 osversion
      C16 QIMEI36
   */
  const qList = [
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.login.getAccountInfo');
      if (handle) {
        handle((info) => {
          if (info) {
            logData[info.type === 1 ? 'C1' : 'C2'] = info.uin;
          }
          resolve();
        });
      } else {
        resolve();
      }
    }),
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.device.getMacAddress');
      if (handle) {
        handle((address) => {
          logData.C3 = typeof address === 'object' ? JSON.stringify(address) : address;
          resolve();
        });
      } else {
        resolve();
      }
    }),
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.device.getQIMEI');
      if (handle) {
        handle((data) => {
          if (typeof data === 'object') {
            logData.C4 = data.QIMEI;
          } else {
            console.log('getQIMEI return wrong data', data);
          }
          resolve();
        }, resolve);
      } else {
        resolve();
      }
    }),
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.app.getAdvertisingID');
      if (handle) {
        handle((str) => {
          logData.C5 = str;
          resolve();
        });
      } else {
        resolve();
      }
    }),
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.device.getIDFV');
      if (handle) {
        handle((str) => {
          logData.C6 = str;
          resolve();
        });
      } else {
        resolve();
      }
    }),
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.device.getAndroidID');
      if (handle) {
        handle((data) => {
          data && (logData.C7 = data.androidID);
          resolve();
        }, resolve);
      } else {
        resolve();
      }
    }),
    // 由于隐私问题，这里不获取用户地理位置，由后台根据 cellid 和 wifimac 计算，或者查询用户 profile
    // new Promise((resolve) => {
    //   const handle = _.get(window, 'browser.app.getGeoLocation');
    //   if (handle) {
    //     handle((data) => {
    //       if (data && data.ret) {
    //         logData.C8 = data.longitude;
    //         logData.C9 = data.latitude;
    //       }
    //       resolve();
    //     }, resolve);
    //   } else {
    //     resolve();
    //   }
    // }),
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.device.getWifiInfo');
      if (handle) {
        handle((data) => {
          if (typeof data === 'object') {
            logData.C10 = data.mac;
            logData.C11 = data.ssid;
          } else {
            console.error('browser.device.getWifiInfo wrong returned value', data);
          }
          resolve();
        });
      } else {
        resolve();
      }
    }),
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.connection.getType');
      if (handle) {
        handle((data) => {
          logData.C13 = data;
          resolve();
        });
      } else {
        resolve();
      }
    }),
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.device.getImsi');
      if (handle) {
        handle((data = '') => {
          logData.C12 = data;
          resolve();
        });
      } else {
        resolve();
      }
    }),
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.device.getIMEI');
      if (handle) {
        handle((data) => {
          if (typeof data === 'object') {
            logData.C14 = data.imei || '';
          } else {
            console.log('getIMEI return wrong data', data);
          }
          resolve();
        }, resolve);
      } else {
        resolve();
      }
    }),
    new Promise((resolve) => {
      const handle = _.get(window, 'browser.device.getVersion');
      if (handle) {
        handle((data) => {
          if (typeof data === 'string') {
            logData.C15 = data || '';
          } else {
            console.log('getVersion return wrong data', data);
          }
          resolve();
        }, resolve);
      } else {
        resolve();
      }
    }),
  ];

  // eslint-disable-next-line new-cap
  return PromiseTImeout(C_TIMEOUT, Promise.all(qList))
    .catch((e) => {
      console.warn('C4PV error', e);
    })
    .then(() => logData);
};
